module.exports = __webpack_public_path__ + "img/ico-facebook.dfdbc48d.svg";